module.exports = __webpack_public_path__ + "media/images/soar/site/plans_1-918abaa36e9b9714bfd7d2f6278d237f.svg";